import { AppSpan, AppText, Button, CustomContainer, FlexRow } from "src/style"
import { AppCenterPopupD2, CenterPopupHeaderD2 } from "src/component"
import { moneyFormat } from "src/utils/utility"
import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

export const ConfirmBillPaymentD2: React.FC<any> = ({data, next, back, close}) => {
    const {info:institutionData} = useContext(AppInfoContext)

    return (
        <AppCenterPopupD2 height='45' zIndex='6' overflow='hidden' close={close}>
            <CenterPopupHeaderD2 title='Confirm Payment' close={close} />
            <CustomContainer 
                height="45"
                style={{maxHeight: '82%'}}
                className="popup-content-container"
            >
                <CustomContainer topMargin="0.5">
                    <AppText align="center">See below transaction confirmation</AppText>
                    <CustomContainer
                        minHeight="12.4" padding="2" 
                        topMargin="1" bgColor="#ffffff"
                        borderColor="#EAECF0" radius="0.8"
                    >
                        <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Bill Category</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.billerCategoryName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Biller</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.billerName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Package</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.paymentItemName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Package code</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.customerUniqueCode}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Amount</AppSpan>
                            <AppText fontWeight="600" color="#212121">{moneyFormat(data?.amount,false,institutionData?.institutionData?.defaultCurrency)}</AppText>
                        </FlexRow>
                    </CustomContainer>
                    <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                        <Button 
                            width='50' sizeUnit="%" height='4.4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            onClick={back}
                        >
                            Back
                        </Button>
                        <Button 
                            width='50' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={next}
                        >
                            Confirm
                        </Button>
                    </FlexRow>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopupD2>
    )
}